import { IconPhoto16 as Icon, InlineText3 as Text } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { ICounter } from './types';

import * as styles from './styles.css';

export const Counter: FC<ICounter> = props => {
  const { currentSlide, totalSlides, className } = props;

  return (
    <div className={clsx(styles['root'], className)}>
      <Icon color="white_100" />
      <span className={styles['caption']}>
        <Text color="white_100">{`${currentSlide}/${totalSlides}`}</Text>
      </span>
    </div>
  );
};

Counter.displayName = 'Counter';
